//TODO: add firebase configuration and export it

//image configuration
export const imageConfig = {
  quality: 0.2,
  maxWidth: 800,
  maxHeight: 600,
  autoRotate: true
};
 export  const firebaseConfig = {
   apiKey: "AIzaSyDHLFIgy2KpAH89hpYFhQq36GSdym4gn40",
   authDomain: "github-finder-9f607.firebaseapp.com",
   databaseURL:
     "https://github-finder-9f607-default-rtdb.asia-southeast1.firebasedatabase.app",
   projectId: "github-finder-9f607",
   storageBucket: "github-finder-9f607.appspot.com",
   messagingSenderId: "790528034079",
   appId: "1:790528034079:web:08aeb3e57acfd8a0789c2a",
   measurementId: "G-458M15CSV2",
 };